<template>
  <div>
    <div class="refuse-order-wrap" v-if="totalElements">
      <div class="msg-item" v-for="item in refuseMsgList" :key="item.id">
        <div class="flex-row-start-center">
          <div class="">
            <span class="bold">服务编码：{{ item.number }}</span>
            <span class="c-65">（{{ item.strTag }}）</span>
          </div>

          <span class="bold m-l-20">{{ item.time }}</span>
        </div>
        <div class="flex-row-between-center m-t-8">
          <span>逾期日：{{ item.expireTime }}</span>
        </div>
      </div>
    </div>
    <div v-else style="text-align: center;color: rgba(0,0,0,0.65);">
      暂无数据
    </div>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :page-size="size"
      :current-page="page"
      :page-sizes="[10, 20, 50, 100]"
      :pager-count="11"
      layout="total, sizes, prev, pager, next"
      :total="totalElements"
      v-if="totalElements"
    >
    </el-pagination>
  </div>
</template>
<script>
import { queryPendingMsg } from "@/models/aftersaleModel";
import moment from "moment";
export default {
  name: "refuseOrder",
  data() {
    return {
      refuseMsgList: [],
      minheight: "300px",
      loading: false,
      page: 1,
      size: 10,
      totalElements: 0,
      moment
    };
  },

  methods: {
    //获取待处理拒收单
    async getList(page, size) {
      console.log("get--refuse");
      const shop_id = Number(localStorage.getItem("shop_id"));
      this.loading = true;
      try {
        const params = {
          shop_id,
          page: page || this.page || 1,
          page_size: size || this.size || 10,
          type: 3 //2-售后，3-拒收
        };
        const res = await queryPendingMsg(params);
        this.loading = false;
        this.refuseMsgList = res.list || [];
        this.totalElements = res.total;
      } catch (error) {
        this.asMsgList = [];
        this.totalElements = 0;
        this.loading = false;
        this.$message.error(error.message);
      }
    },
    // 每页条数
    handleSizeChange(val) {
      this.loading = true;
      this.size = val;
      this.page = 1;
      this.getList(1, val);
    },
    // 页码改变
    handleCurrentChange(val) {
      this.loading = true;
      this.page = val;
      this.getList(val, this.size);
    }
  }
};
</script>
<style lang="scss" scoped>
.refuse-order-wrap {
  color: rgba(0, 0, 0, 0.65);
  font-size: 14px;
  max-height: 460px;
  overflow-y: scroll;
  border-bottom: 1px solid #e9e9e9;
  padding: 0 16px;
  .msg-item {
    border: 1px solid #e9e9e9;
    padding: 16px;
    margin-bottom: 12px;
    .bold {
      color: rgba(0, 0, 0, 0.85);
      font-weight: bold;
    }
    .m-t-8 {
      margin-top: 8px;
    }
    .m-l-20 {
      margin-left: 20px;
    }
    .sku-width {
      width: 130px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pendingOrder/refuseOrder.vue